import { EMPTY_VALUE, FieldSchema } from "../../../Schema";
import { Site } from "../external-sources/Sites";

export const siteId: FieldSchema = {
  name: "siteId",
  data: {
    assignedValue: {
      getter: ({ siteName }) => {
        if (siteName) {
          return (siteName as Site).siteId ?? EMPTY_VALUE;
        }
        return EMPTY_VALUE;
      },
      fields: ["siteName"],
    },
  },
  form: { label: "Site ID", disabled: true, displayed: false },
};
